import { RESOURCE_NAME } from '@esentai/core/features/bonus_transactions/consts';
import { canRead } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadBonusTransactionLevelHistory = authorizeIf(
  canRead(RESOURCE_NAME),
);
